// Cache simples em memória para exibir dados na hora (stale-while-revalidate).
const mem = new Map();

export function getCache(key) {
  return mem.has(key) ? mem.get(key) : undefined;
}

export function setCache(key, value) {
  mem.set(key, value);
}
